module.exports = __webpack_public_path__ + "static/fipcahoywhale2-aa70fc9643e035d10edff293087ca162.jpeg";